import React from "react";
import { useLocation } from "react-router-dom";
import { Tabs, Tab, makeStyles, Theme, withStyles } from "@material-ui/core";
import { Archive, Flag, AssignmentInd, Alarm, EventAvailable, AssignmentTurnedIn } from "@material-ui/icons";
import { MentorLocalizations } from "../../../Shared/sharedTypes";
import { Link } from "react-router-dom";

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.paper,
        display: "flex",
        // height: 224,
    },

    tabWrapper: {
        flexDirection: "row",
        justifyContent: "flex-start",
        paddingLeft: 20,
        fontSize: ".9em",
        color: "#fff",
        "& > svg": {
            marginRight: 12,
            color: "#ffffff88",
        },
    },
    tabLabelIcon: {
        minHeight: "auto",
        paddingTop: 0,
    },
}));

interface propsType {
    forwardedRef?: any;
    localizations: MentorLocalizations;
}

export const MyTabs = withStyles((theme: Theme) => ({
    root: {
        borderRight: `1px solid ${theme.palette.divider}`,
        marginTop: 20,
    },
    // flexContainer: {
    //     borderBottom: "4px solid " + theme.palette.primary.light,
    // },
    indicator: { backgroundColor: "#fff", width: 4 },
}))(Tabs);

export default function MainTabs(props: propsType) {
    const classes = useStyles();

    const loc = useLocation().pathname.toLowerCase().split("/");
    let val = "/" + (loc[1].length > 1 ? loc[1] : "queue");

    const [value, setValue] = React.useState(val);
    const { localizations } = props;

    function handleChange(event: any, newValue: any) {
        setValue(newValue);
    }

    return (
        <>
            <MyTabs value={value} onChange={handleChange} orientation="vertical">
                <Tab
                    to="/assigned"
                    classes={{ wrapper: classes.tabWrapper, labelIcon: classes.tabLabelIcon }}
                    value="/assigned"
                    component={Link}
                    icon={<AssignmentInd />}
                    label={localizations.AssignedToMe}
                />
                <Tab
                    to="/queue"
                    classes={{ wrapper: classes.tabWrapper, labelIcon: classes.tabLabelIcon }}
                    value="/queue"
                    component={Link}
                    icon={<Alarm />}
                    label={localizations.WaitingQueue}
                />
                <Tab
                    to="/upcoming"
                    classes={{ wrapper: classes.tabWrapper, labelIcon: classes.tabLabelIcon }}
                    value="/upcoming"
                    component={Link}
                    icon={<EventAvailable />}
                    label={localizations.Upcoming}
                />
                <Tab
                    to="/active"
                    value="/active"
                    classes={{ wrapper: classes.tabWrapper, labelIcon: classes.tabLabelIcon }}
                    component={Link}
                    icon={<Flag />}
                    label={localizations.Active}
                />
                <Tab
                    to="/signoff"
                    value="/signoff"
                    component={Link}
                    classes={{ wrapper: classes.tabWrapper, labelIcon: classes.tabLabelIcon }}
                    icon={<AssignmentTurnedIn />}
                    label={localizations.WaitingForSignOff}
                />
                <Tab
                    to="/completed"
                    value="/completed"
                    component={Link}
                    classes={{ wrapper: classes.tabWrapper, labelIcon: classes.tabLabelIcon }}
                    icon={<Archive />}
                    label={localizations.CompletedQueue}
                />
            </MyTabs>
        </>
    );
}
